export default __webpack_public_path__ + "static/link-item-icon-dont-16a195259ecaa869a1a98b21ee14646e6f2b520e6a5915c5b878c986e7bd17b1.png";